import React, { useState } from 'react';
import { css } from '@emotion/react';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import ContentLoader from 'react-content-loader';

import { typography } from '~/src/styles';

import { useSeasonsState } from './SeasonsProvider';

const styles = {
  select: css(typography.mobileBodyText, {
    color: 'var(--Grey-Text, #585858)',
    borderRadius: '4px',
    borderBottom: '1px solid #2CB3C6',
    background: '#FFF',
    boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.08)',
    marginBottom: '24px',
    height: '50px',
    '.MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '.MuiSelect-select': {
      paddingRight: '60px !important',
    },
    '.MuiSvgIcon-root': {
      width: '40px',
      height: 'auto',
      top: '5px',
    },
  }),
  openedSelect: css({
    borderBottomLeftRadius: '0px',
    borderBottomRightRadius: '0px',
  }),
  option: css(typography.mobileBodyText, {
    color: 'var(--Grey-Text, #585858)',
    height: '50px',
  }),
  selectedOption: css({
    background: 'rgba(255, 255, 255, 0.20)',
  }),
  menuList: css({
    paddingBottom: 0,
  }),
};
const theme = createTheme({
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          borderTopLeftRadius: '0px',
          borderTopRightRadius: '0px',
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        list: styles.menuList,
      },
    },
  },
});

const Placeholder: React.FC = () => {
  const width = 160;
  const height = 56;
  return (
    <ContentLoader
      style={{ height, width }}
      foregroundColor="#f3f3f3"
      backgroundColor="var(--Grey-Accent-Color)"
      height={height}
      width={width}
      speed={3}
      uniqueKey={`c.h${height}.w${width}`}
    >
      <rect x={0} y={0} rx={10} ry={10} height={height} width={width} />
    </ContentLoader>
  );
};

export const SeasonSelector: React.FC = () => {
  const { seasonsList, onActiveSeasonChange, activeSeason, loading } = useSeasonsState();
  const [open, setOpen] = useState(false);
  if (loading) {
    return <Placeholder />;
  }

  return (
    <ThemeProvider theme={theme}>
      <Select
        value={activeSeason?.id ?? null}
        onChange={({ target: { value } }) => onActiveSeasonChange(value)}
        id="select-season"
        open={open}
        onOpen={() => {
          setOpen(true);
        }}
        onClose={() => setOpen(false)}
        css={[styles.select, open && styles.openedSelect]}
      >
        {seasonsList.map(item => (
          <MenuItem
            key={item.id}
            value={item.id}
            css={[styles.option, item.id === activeSeason?.id && styles.selectedOption]}
          >
            {item.title}
          </MenuItem>
        ))}
      </Select>
    </ThemeProvider>
  );
};
